import base64 from 'base-64'
import utf8 from 'utf8'
import onboardingTypes from 'Enums/onboardingTypes'

const encode = value => base64.encode(utf8.encode(value))
const decode = value => utf8.decode(base64.decode(value))

const key = encode('mpOnboarding-v2')


export const getOnboardingStatus = () => {
  const enumerator = localStorage.getItem(key) || ''

  return parseInt(decode(enumerator)) || onboardingTypes.none
}

export const getCompanyOnboarding = (isFromSnet = false) => {
  const { migrationCompany, newCompany } = onboardingTypes

  return isFromSnet ? migrationCompany : newCompany
}

export const getUserOnboarding = (isFromSnet = false) => {
  const { migrationUser, newUser } = onboardingTypes

  return isFromSnet ? migrationUser : newUser
}

export const enableOnboarding = ({ isCompany = false, isSnetUser = false }) => {
  let enumerator = onboardingTypes.none

  if (isCompany) {
    enumerator = getCompanyOnboarding(isSnetUser)
  } else {
    enumerator = getUserOnboarding(isSnetUser)
  }

  localStorage.setItem(key, encode(enumerator.toString()))

  return enumerator
}

export const disableOnboarding = () => {
  localStorage.setItem(key, encode(onboardingTypes.none.toString()))
}

export const removeOnboarding = () => {
  localStorage.removeItem(key)
}

export default {
  getOnboardingStatus,
  enableOnboarding,
  disableOnboarding,
  removeOnboarding,
}